<template>
  <div class="root">
    <h2 class="mb-2" style="font-weight:bold;">Réponse en français</h2>
    <pre class="text_fr" style="white-space: pre-wrap;word-wrap: normal;display: block;">{{ text_fr }}</pre>

    <h2 v-if="text_native" class="mb-2 mt-5" style="font-weight:bold;">Réponse traduite</h2>
    <pre v-if="text_native" class="text">{{ text_native }}</pre>

    <h2 v-if="text_signaling" class="mb-2 mt-5" style="font-weight:bold;">Demande de signalement</h2>
    <pre v-if="text_signaling" class="text">{{ text_signaling }}</pre>
  </div>
</template>

<script>
import REVIEW_CONTENT from '@/gql/queries/reviewContent.graphql';
import { gqlQuery } from '@/gqlClient.js';

export default {
  name: "EstablishmentReviewContent",
  props: {
    review: {
      type: Object
    }
  },
  data() {
    return {
      text_fr: "",
      text_native: "",
      text_signaling: ""
    }
  },
  async mounted() {
    const resp = await gqlQuery(REVIEW_CONTENT, { review_uid: this.review.uid })
    this.text_fr = resp.body.data.review_content.text_fr
    this.text_native = resp.body.data.review_content.text_native
    this.text_signaling = resp.body.data.review_content.text_signaling
    console.log("text_signaling", this.text_signaling)
  }
}
</script>